/* eslint-disable @next/next/no-img-element */
import { Dispatch, FC, SetStateAction } from 'react';

import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

import { Buttons } from './styles';
import augusto from '../../../../../public/images/augusto.jpeg';

interface IAugustoInsightsMobileAlertModalProps {
  closeMobileSidebar: () => void;
  setOpenMobileAugustoPostsModal?: Dispatch<SetStateAction<boolean>>;
  close: () => void;
}
export const AugustoInsightsMobileAlertModal: FC<
  IAugustoInsightsMobileAlertModalProps
> = ({ closeMobileSidebar, setOpenMobileAugustoPostsModal, close }) => {
  const handleOpenMobileAugustoPostsModal = (): void => {
    closeMobileSidebar();
    setTimeout(() => {
      setOpenMobileAugustoPostsModal?.(true);
    }, 150);
  };

  return (
    <Modal
      id="augusto-posts-modal"
      isOpen
      onClose={close}
      height="184px"
      width="100%"
      topRightContent={
        <img
          src={augusto.src}
          alt=""
          style={{ width: '36px', height: '36px', borderRadius: '50%' }}
          draggable={false}
        />
      }
    >
      <Typography.Label size="medium">
        Novo conteúdo disponível
      </Typography.Label>

      <Buttons>
        <Button
          text="Clique aqui para acessar"
          width="100%"
          onClick={handleOpenMobileAugustoPostsModal}
          justifyContent="center"
        />
      </Buttons>
    </Modal>
  );
};
